import { checkResponse, parseJSONDate } from "src/components/js/statics1";
import { findSijaintiForKeikkaFromAsiakasPriority } from "./components/findSijaintiForKeikkaFromAsiakasPriority";
import { findSijaintiForKeikkaFromHistory } from "./components/findSijaintiForKeikkaFromHistory";
import { findSijaintiForKeikkaFromRefLink } from "./components/findSijaintiForKeikkaFromRefLink";
import { sijainti_calculateDistance, sijainti_get } from "./SijaintiFunctions";
import { asiakas_fetch } from "../asiakas/AsiakasFunctions";
import {
  fetchDefaultBetonitoimittajaAsiakasId,
  fetchDefaultPumpputoimittajaAsiakasId,
} from "../person/PersonFunctions";
import { cache_clear, cache_read, cache_write } from "src/components/js/CacheFunctions";

export default class sijaintiClass {
  constructor() {
    this.sijaintiId = 0;
    this.asiakasId = 0;
    this.sijaintiNimi = null;
    this.sijaintiTypeId = null;
    this.sijaintiLyh = null;
    this.sijaintiOsoite1 = null;
    this.sijaintiOsoite2 = null;
    this.sijaintiPhone = null;
    this.sijaintiComment = null;
    this.maxDeliveryDistance = null;
  }

  isValid = () => {
    if (this.asiakasId === 0) return false;
    if (this.sijaintiNimi === null) return false;
    if (this.sijaintiTypeId === null) return false;
    if (this.sijaintiLyh === null) return false;
    if (this.sijaintiOsoite1 === null) return false;
    if (this.sijaintiOsoite2 === null) return false;
    if (this.sijaintiPhone === null) return false;
    if (this.maxDeliveryDistance === null) return false;
    return true;
  };
}

export async function getDrivingDistanceSimple(
  originLat,
  originLng,
  destLat,
  destLng,
  ownerAsiakasId,
  token,
  forceUpdateFromGoogle = false
) {
  const a = await getDrivingDistance(
    originLat,
    originLng,
    destLat,
    destLng,
    ownerAsiakasId,
    token,
    forceUpdateFromGoogle
  );

  let matkaM = a.matkaM;
  if (!matkaM && a[0]) matkaM = a[0].matkaM;
  if (!matkaM && a.rows) matkaM = a.rows[0].elements[0].distance.value;
  let matkaAika = a.matkaAika;
  if (!matkaAika && a[0]) matkaAika = a[0].matkaAika;
  if (!matkaAika && a.rows) matkaAika = a.rows[0].elements[0].duration.value;
  return { matkaM: Number(matkaM), min: Number(matkaAika), matkaAika: Number(matkaAika) };
}

export async function getDrivingDistance(
  originLat,
  originLng,
  destLat,
  destLng,
  ownerAsiakasId,
  token,
  forceUpdateFromGoogle = false
) {
  const requestOptions = {
    method: "POST",
    headers: {
      "x-access-token": `${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      originLat: originLat,
      originLng: originLng,
      destLat: destLat,
      destLng: destLng,
      ownerAsiakasId: ownerAsiakasId,
      forceUpdateFromGoogle: forceUpdateFromGoogle,
    }),
  };
  const url = import.meta.env.VITE_SERVER_URL + "/api/geocode/getDrivingDistance";
  const urlKey = url + "/" + originLat + "/" + originLng + "/" + destLat + "/" + destLng;
  if (!forceUpdateFromGoogle) {
    cache_clear("getDrivingDistance");
    const c = cache_read("getDrivingDistance", urlKey);
    if (c) return c.data;
  }
  const response = await fetch(url, requestOptions);
  const a = await checkResponse(response, "sijaintiClass:getDrivingDistance");
  cache_write("getDrivingDistance", urlKey, a, 360);
  return {
    drivingDistanceId: a.data.drivingDistanceId,
    entryTime: parseJSONDate(a.data.entryTime),
    forceUpdateFromGoogle: forceUpdateFromGoogle,
    matkaAika: a.data.matkaAika,
    matkaM: a.data.matkaM,
    source: a.data.source,
  };
  // return a.data;
}

export async function findClosestSijaintiForKeikka(keikkaData, personId, ownerAsiakasId, token) {
  const keikkaId = keikkaData.keikkaId;
  // 1. Onko aikaisemmin tallennettu sijaintiId tälle tyomaaId, asiakasId tai keikkaContactPersonId ?
  //    jos on niin käytä sitä. Esim. jos on ollut Rudus, niin on taas Rudus.
  // 2. Löytyykö ref linkkiä, josta löytyy sijaintiId.
  // 3. Tarkista löytyykö ensisijaisen asiakasId:n läheltä sijainti. Jos löytyy, niin käytä sitä.
  //    Esim. ensin käydään kaikki Ruduksen tehtaat läpi ja valitaan lähin mikäli on lähellä, <50km
  // 3. Tarkista sitten muiden asiakkaiden sijannit ja valitaan lähin mikäli on lähellä, <50km
  // fetch findSijaintiForKeikkaFromHistory
  // fetch findSijaintiForKeikkaFromRefLink
  // fetch findSijaintiForKeikkaFromAsiakas

  let result = null;

  // hae aikaisemmin tallennettu sijainti tälle tyomaalle
  result = await findSijaintiForKeikkaFromHistory(keikkaId, token);
  if (result === null) {
    console.log("findSijaintiForKeikkaFromHistory returned null");
  }
  if (!result || !result[0].betoniSijaintiId) {
    result = await findSijaintiForKeikkaFromRefLink(keikkaId, token);
    if (result && result[0].betoniSijaintiLat > 0) {
      result[0].betoniSijaintiKm = sijainti_calculateDistance(
        result[0].betoniSijaintiLat,
        result[0].betoniSijaintiLng,
        keikkaData.tyomaa.lat,
        keikkaData.tyomaa.lng
      );
      result[0].pumppuSijaintiKm = sijainti_calculateDistance(
        result[0].pumppuSijaintiLat,
        result[0].pumppuSijaintiLng,
        keikkaData.tyomaa.lat,
        keikkaData.tyomaa.lng
      );
    }
  }
  // jos historiasta löytyi sijainti, niin ei tarvitse etsiä enää
  // if we have result[0].betoniSijaintiLat: we have all info, no need to fetch more
  if (!result || !result[0].betoniSijaintiId) {
    // if we have result[0].betoniAsiakasId and/or result[0].betoniAsiakasId, treat as refLink
    const address = null;
    const defaultPumppuAsiakasId = await fetchDefaultPumpputoimittajaAsiakasId(personId, token);
    const defaultBetoniAsiakasId = await fetchDefaultBetonitoimittajaAsiakasId(personId, token);
    result = await findSijaintiForKeikkaFromAsiakasPriority(
      keikkaData,
      address,
      ownerAsiakasId,
      token,
      defaultPumppuAsiakasId,
      defaultBetoniAsiakasId
    );
  }

  // kun meillä on oikea sijainti, niin haetaan matkam
  const _betoniDistance = await getDrivingDistanceSimple(
    result[0].betoniSijaintiLat,
    result[0].betoniSijaintiLng,
    keikkaData.tyomaa.lat,
    keikkaData.tyomaa.lng,
    ownerAsiakasId,
    token
  );
  result[0].betoniMatkaM = _betoniDistance.matkaM;
  result[0].betoniMatkaAika = _betoniDistance.min;

  const _pumppuDistance = await getDrivingDistanceSimple(
    result[0].pumppuSijaintiLat,
    result[0].pumppuSijaintiLng,
    keikkaData.tyomaa.lat,
    keikkaData.tyomaa.lng,
    ownerAsiakasId,
    token
  );
  result[0].pumppuMatkaKm = _pumppuDistance.matkaM;
  result[0].pumppuMatkaAika = _pumppuDistance.min;

  const _n = {
    betoniAsiakasId: result[0].betoniAsiakasId,
    betoniSijaintiId: result[0].betoniSijaintiId,
    betoniSijaintiKm: result[0].betoniSijaintiKm,
    betoniSijaintiLat: result[0].betoniSijaintiLat,
    betoniSijaintiLng: result[0].betoniSijaintiLng,
    pumppuAsiakasId: result[0].pumppuAsiakasId,
    pumppuSijaintiId: result[0].pumppuSijaintiId,
    pumppuSijaintiKm: result[0].pumppuSijaintiKm,
    pumppuSijaintiLat: result[0].pumppuSijaintiLat,
    pumppuSijaintiLng: result[0].pumppuSijaintiLng,
    pumppuMatkaM: result[0].pumppuMatkaKm,
    pumppuMatkaAika: result[0].pumppuMatkaAika,
    betoniMatkaM: result[0].betoniMatkaM,
    betoniMatkaAika: result[0].betoniMatkaAika,
  };
  return _n;
}

export async function setBetoniToimittajaData(
  keikkaData,
  person,
  betoniAsiakasId,
  betoniSijaintiId,
  betoniMatkaM,
  betoniMatkaAika,
  token,
  laskuttajaAsiakasId
) {
  keikkaData.betoniToimittaja.asiakasId = betoniAsiakasId;
  keikkaData.betoniToimittaja.sijaintiId = betoniSijaintiId;
  keikkaData.betoniToimittaja.sijaintiMatkaM = betoniMatkaM;
  keikkaData.betoniToimittaja.sijaintiMatkaAika = betoniMatkaAika;
  keikkaData.betoniToimittaja.sijainti = await sijainti_get(
    keikkaData.betoniToimittaja.sijaintiId,
    token
  );
  const fetchResult = await asiakas_fetch(
    person,
    betoniAsiakasId,
    token,
    keikkaData,
    laskuttajaAsiakasId,
    true,
    true
  );
  const keikkaAsiakas = fetchResult.keikkaAsiakas;
  keikkaData.betoniToimittaja.asiakasId = keikkaAsiakas.asiakasId;
  keikkaData.betoniToimittaja.asiakasNimi = keikkaAsiakas.asiakasNimi;
}
export async function setPumppuToimittajaData(
  keikkaData,
  person,
  pumppuAsiakasId,
  pumppuSijaintiId,
  pumppuMatkaM,
  pumppuMatkaAika,
  token,
  laskuttajaAsiakasId
) {
  keikkaData.pumppuToimittaja.asiakasId = pumppuAsiakasId;
  keikkaData.pumppuToimittaja.sijaintiId = pumppuSijaintiId;
  keikkaData.pumppuToimittaja.sijaintiMatkaM = pumppuMatkaM;
  keikkaData.pumppuToimittaja.sijaintiMatkaAika = pumppuMatkaAika;
  keikkaData.pumppuToimittaja.sijainti = await sijainti_get(
    keikkaData.pumppuToimittaja.sijaintiId,
    token
  );
  const fetchResult = await asiakas_fetch(
    person,
    pumppuAsiakasId,
    token,
    keikkaData.keikkaId,
    laskuttajaAsiakasId,
    true,
    true
  );
  const keikkaAsiakas = fetchResult.keikkaAsiakas;
  keikkaData.pumppuToimittaja.asiakasId = keikkaAsiakas.asiakasId;
  keikkaData.pumppuToimittaja.asiakasNimi = keikkaAsiakas.asiakasNimi;
}
